import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import {Grid, Paper, TextField} from "@mui/material";
import * as QueryActions from "../../../actions";
import * as GeneActions
  from "../../dashboard/components/genomics-dashboard/components/side-panels/filter-panel/components/filter-sections/actions";
import * as PositionActions
  from "../../dashboard/components/genomics-dashboard/components/side-panels/filter-panel/components/filter-sections/position-section/position_actions";
import {query_sample} from "../../../services/api/genomics_query_samples/query_sample";
import {postFilterSet} from "../../../services/api/manage_study";
import {default_filters} from "../../../config-files/configFilters";
import CaButton from "../../../gpap-lib/components/shared-components/CaButton";
import MappedText from "../../study-page/create-study/analysis-page/components/clinical-info/mapText";
import All_Filters_Accordion
  from "../../dashboard/components/genomics-dashboard/components/side-panels/filter-panel/components/filter-accordion-panels/All_Filters_Accordion";
import FilterSetView from "./FilterSetView";
import { useTranslation } from "react-i18next";

function date_generator() {
  return new Date().toISOString();
}

function FilterSets_Manager(props) {
  const { queryActions, query } = props;
  const [showCreate, setShowCreate] = useState(false);
  const [filterName, setFilterName] = useState("");
  const [description, setDescription] = useState("");
  const { t } = useTranslation();

  useEffect(() => {
    if (Object.keys(query).length === 0) {
      queryActions.updateQuery(query_sample);
    }
  }, [query, queryActions]);
  

  const handleCreateNew = () => {
    setFilterName("");
    setDescription("");
    setShowCreate(true);
  };

  const handleCancel = () => {
    setFilterName("");
    setDescription("");
    setShowCreate(false);
  };

  const handleCreate = () => {
    const filters_to_save = { ...props.query };
    delete filters_to_save["samples_germline"];
    
  
    console.log("Filtros a guardar:", filters_to_save); 
  
    const filter_set_obj = {
      filter_set_name: filterName,
      filters: filters_to_save,
      creationDate: date_generator(),
      description: description
    };

    postFilterSet(
      window.config.apis_configuration.api_nextgpap_server,
      props.token,
      filter_set_obj
    )
      .then(resp => resp.json())
      .then(() => {
        setFilterName("");
        setDescription("");
        setShowCreate(false);
      });
  };

  if (!showCreate) {
    return (
      <div>
        <Grid container direction="row">
          <Grid item lg={12}>
            <Typography variant="h5" gutterBottom>
              <MappedText text="Filter Sets"/>
            </Typography>
          </Grid>
          <Grid item lg={12}>
            <Box p={1}>
              <FilterSetView onCreateNew={handleCreateNew} />
            </Box>
          </Grid>
        </Grid>
      </div>
    );
  } else {
    return (
      <Box p={2}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h6"><MappedText text="Create Filter Set"/></Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1" gutterBottom>
              <MappedText text="This will create a new filter set that will appear in the Predefined Filters list when you create new queries in your interpretation requests."/>
            </Typography>
            <Typography variant="body1" gutterBottom style={{ fontWeight: "bold" }}>
              <MappedText text="Currently these filters only apply to SNVs and InDels" />
            </Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              label={t("Filter Name")}
              fullWidth
              value={filterName}
              onChange={(e) => setFilterName(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label={t("Description")}
              fullWidth
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
           
            <All_Filters_Accordion
            default_filters={default_filters}
            somatic={props.somatic}
            query={query}
            updateQuery={queryActions.updateQuery}
            />

          </Grid>
        </Grid>

        <Paper
          elevation={3}
          sx={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            height: "50px",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            zIndex: 1000
          }}
        >
          <CaButton
            text={t("Cancel")}
            variant="outlined"
            size="large"
            onClick={handleCancel}
            customStyles={{ marginRight: "20px" }}
          />
          <CaButton
            text={t("Create")}
            variant="contained"
            size="large"
            onClick={handleCreate}
            customStyles={{ marginRight: "20px" }}
          />
        </Paper>
      </Box>
    );
  }
}

function mapStateToProps(state) {
  if (state.authorization !== undefined) {
    return {
      token: state.authorization.token,
      query: state.query
    };
  }
}

const mapDispatchToProps = (dispatch) => ({
  queryActions: bindActionCreators(QueryActions, dispatch),
  geneActions: bindActionCreators(GeneActions, dispatch),
  positionActions: bindActionCreators(PositionActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(FilterSets_Manager);
